var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({attrs:{"dense":"","outlined":"","hide-details":"","label":"Sport","items":_vm.SupportedSports,"value":_vm.value,"append-icon":_vm.BAIcons.expand},on:{"input":_vm.input}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }